(() => {
  if (window.__HF_STACKING_CARDS_INIT__) return;
  window.__HF_STACKING_CARDS_INIT__ = true;

  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
  const valueAt = (from, to, p) => from + (to - from) * p;

  const observers = new WeakMap();

  function tearDown(root) {
    const existing = observers.get(root);
    if (!existing) return;
    window.removeEventListener('scroll', existing.onScroll);
    window.removeEventListener('resize', existing.onResize || existing.onScroll);
    if (existing.ro) existing.ro.disconnect();
    observers.delete(root);
  }

  function init(root) {
    tearDown(root);

    const cards = Array.from(root.querySelectorAll('[data-hf-stacking-card]'));
    if (cards.length === 0) return;

    cards.forEach((card, index) => {
      card.style.paddingTop = `${20 + index * 20}px`;
      card.style.minHeight = '';
    });

    if (cards.length < 2) return;

    const inners = cards.map((c) => c.querySelector('[data-hf-stacking-card-inner]'));
    function syncCardHeights() {
      inners.forEach((el) => { if (el) el.style.minHeight = ''; });
      requestAnimationFrame(() => {
        const heights = inners.map((el, i) => (el ? el.offsetHeight : cards[i].offsetHeight));
        const maxHeight = Math.max(...heights);
        inners.forEach((el) => { if (el) el.style.minHeight = maxHeight + 'px'; });
      });
    }
    syncCardHeights();

    let roTicking = false;
    let lastMaxH = 0;
    const ro = new ResizeObserver(() => {
      if (roTicking) return;
      const currentMax = Math.max(...inners.map((el, i) => (el ? el.scrollHeight : cards[i].offsetHeight)));
      if (currentMax === lastMaxH) return;
      lastMaxH = currentMax;
      roTicking = true;
      requestAnimationFrame(() => {
        syncCardHeights();
        roTicking = false;
      });
    });
    cards.forEach((c) => ro.observe(c));

    if (document.readyState !== 'complete') {
      window.addEventListener('load', syncCardHeights, { once: true });
    }

    const configs = cards.slice(0, -1).map((card, index) => {
      const toScale = 1 - (cards.length - 1 - index) * 0.1;
      const inner = card.querySelector('[data-hf-stacking-card-inner]');
      return { inner, toScale, index };
    });

    function compute() {
      const lastCard = cards[cards.length - 1];
      const wrapperTop = root.getBoundingClientRect().top;
      const totalScrollable = root.offsetHeight - lastCard.offsetHeight;
      if (totalScrollable <= 0) return;
      const progressGlobal = clamp(-wrapperTop / totalScrollable, 0, 1);

      const segments = configs.length;
      const segmentSize = 1 / segments;

      configs.forEach((cfg) => {
        const segmentStart = cfg.index * segmentSize;
        const localP = clamp((progressGlobal - segmentStart) / segmentSize, 0, 1);
        cfg.inner.style.scale = valueAt(1, cfg.toScale, localP);
        cfg.inner.style.filter = `brightness(${valueAt(1, 0.8, localP)})`;
      });
    }

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        compute();
        ticking = false;
      });
    };

    const onResize = () => {
      syncCardHeights();
      onScroll();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    observers.set(root, { onScroll, onResize, ro });
    onScroll();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hf-stacking-cards]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:load', (e) => {
    const root = e.target.closest('[data-hf-stacking-cards]') || e.target;
    initAll(root.parentElement || document);
  });
})();
